
import { supabase } from "@/integrations/supabase/client";
import { 
  getUserPhoneNumber, 
  getOrCreateHostSpecialInvite, 
  sendSMSNotification 
} from "./hostNotificationService";

/**
 * Sends a notification to the host when recommendations are available
 * @param eventId The event ID
 * @param hostId The host user ID
 * @returns Success status of the operation
 */
export async function sendRecommendationsAvailableNotification(
  eventId: string,
  hostId: string
): Promise<boolean> {
  try {
    console.log(`Sending recommendations notification for event ${eventId} to host ${hostId}`);
    
    // Get host phone number
    const hostPhone = await getUserPhoneNumber(hostId);
    if (!hostPhone) {
      console.error("Host phone number not found");
      return false;
    }
    
    // Verify recommendations exist
    const { data: recommendations, error: recoError } = await supabase
      .from('event_date_recommendations')
      .select('recommendation_id')
      .eq('event_id', eventId)
      .limit(1);
    
    if (recoError || !recommendations || recommendations.length === 0) {
      console.error("No recommendations found for event");
      return false;
    }
    
    // Create a special "host" invite record for this notification
    const hostInviteId = await getOrCreateHostSpecialInvite(eventId, hostId);
    
    if (!hostInviteId) {
      console.error("Failed to create host notification invite");
      return false;
    }
    
    // Send the notification
    return await sendSMSNotification(
      eventId,
      hostInviteId,
      'recommendations_available_host',
      hostPhone
    );
  } catch (error) {
    console.error("Error sending recommendations notification:", error);
    return false;
  }
}
